export default {
	title: 'safety',
	components: [{ title: 'max_current_protection', component: 'max_current_protection_g2' }],
};
